//вычисление координат через угол и расстояние
export const calcCoordinate = (latitude, longitude, radius, angle) => {
    const x = latitude + Math.cos(angle * Math.PI / 180) * (radius / 111134.861111);
    const y = longitude + Math.sin(angle * Math.PI / 180) * (radius / (Math.cos(latitude * Math.PI / 180) * 111321.377778));
    return [x, y];
  };

  ////// Функция для генерации точек дуги разрешенной зоны (когда включены барьеры)
export const generateArcPoints = (center, radius, startAngle, endAngle, steps = 36) => {
    const points = [];
    let angleDiff = endAngle - startAngle;
    
    if (angleDiff < 0) angleDiff += 360;
    const step = angleDiff / steps;
    
    for (let i = 0; i <= steps; i++) {
      const currentAngle = startAngle + step * i;
      points.push(calcCoordinate(center[0], center[1], radius, currentAngle));
    }
    return points;
  };
